import BranchPanel from "./branchPanel.container";

export default BranchPanel;
